<template>
  <div class="not-found__wrapper">
    <div class="wrapper wrapper-full-page">
      <div class="full-page not-found-page login-page">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-8 col-md-6 ml-auto mr-auto text-center">
              <h1 class="text-white mt-3 error_page-code">404</h1>
              <small class="text-white error_page-message">{{$t('error.page.message')}}<br>
                {{$t('error.page.message.second')}}
              </small>
              <div class="error_page-button" @click="goHome">Home page</div>
            </div>
          </div>
        </div>
      </div>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
  import { Card, InfoSection } from 'src/components/index'
  import AppNavbar from 'src/views/public/layout/AppNavbar'
  import AppFooter from 'src/views/public/layout/AppFooter'

  export default {
    components: {
      Card,
      AppNavbar,
      AppFooter,
      InfoSection
    },
    methods: {
      goHome () {
        this.$router.push({path: '/profile/dashboard'})
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style lang="scss" scoped>
  .not-found__wrapper .content {
    background-color: $secondary-dark;
    min-height: calc(100vh - 110px);
  }

  .not-found__wrapper .wrapper-full-page {
    display: flex;
    flex-direction: column;
  }

  .not-found__wrapper /deep/ .container-fluid {
    display: flex;
    justify-content: flex-end;
    padding-right: 50px;
  }
  .not-found__wrapper /deep/ .footer {
    background-color: $secondary-dark;
  }
</style>
